import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { createApiUrl } from '../utils/apiConfig';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Call backend logout endpoint
        await axios.post(createApiUrl('/api/logout'), {}, {
          withCredentials: true
        });
      } catch (error) {
        console.error('Error during logout:', error);
      } finally {
        // Clear local auth state
        logout();
        // Redirect to login page
        navigate('/login');
      }
    };

    performLogout();
  }, [logout, navigate]);

  return (
    <div className="container mt-5">
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Logging out...</span>
        </div>
        <p className="mt-3">Logging out...</p>
      </div>
    </div>
  );
};

export default Logout; 